import * as React from "react"

import { useBounceGlobalValues, useTranslation } from "@bounce/i18n"
import { CTA } from "@bounce/web-components"

import { useUrl } from "../../../../libs/router"
import { useAppURL } from "../../../../utils/appURL"

export type BookNowProps = {
  className?: string
}

export const BookNow = ({ className }: BookNowProps) => {
  const { t } = useTranslation("marketing-generic")
  const bounceGlobals = useBounceGlobalValues()

  const buildAppURL = useAppURL()
  const { getUrl } = useUrl()
  const url = buildAppURL(getUrl({ path: "/s" }))

  return (
    <CTA
      title={t("screen.reviews.findClosestLocationTitle", "Store your luggage anywhere")}
      subtitle={t("screen.reviews.findClosestLocationSubtitleV6", "{{numLocations}}+ locations to store your luggage", {
        numLocations: bounceGlobals.numLocations,
      })}
      ctaLabel={t("screen.reviews.findClosestLocationCta", "Find closest location")}
      ctaHref={url}
      ctaRel="nofollow"
      className={className}
    />
  )
}
